import api from './api';

export interface DashboardMetrics {
  // Common metrics
  active_cases?: number;
  meeting_slots?: number;
  intake_form_required?: number;
  upcoming_deadlines?: number;
  
  // Admin specific metrics
  total_firms?: number;
  pending_firm_approvals?: number;
  total_users?: number;
  recent_cases?: number;
  
  // Firm admin specific metrics
  total_cases?: number;
  firm_completed_cases?: number;
  firm_pending_approval?: number;
  
  // Expert user specific metrics
  assigned_cases?: number;
  active_assigned_cases?: number;
  upcoming_meetings?: number;
  expert_completed_cases?: number;
  
  // Regular user specific metrics
  my_cases?: number;
  active_my_cases?: number;
  user_pending_approval?: number;
}

export interface RecentActivity {
  id: number;
  case_name: string;
  status: string;
  firm_name: string;
  service_type: string;
  created_by: string;
  created_at: string;
  due_date: string;
}

class DashboardService {
  /**
   * Get dashboard metrics based on user role
   */
  async getMetrics(): Promise<DashboardMetrics> {
    try {
      const response = await api.get('/dashboard/metrics');
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard metrics:', error);
      throw error;
    }
  }

  /**
   * Get recent activity for dashboard
   */
  async getRecentActivity(limit = 10): Promise<RecentActivity[]> {
    try {
      const response = await api.get(`/dashboard/recent-activity?limit=${limit}`);
      return response.data.recent_activity;
    } catch (error) {
      console.error('Error fetching recent activity:', error);
      throw error;
    }
  }
}

export default new DashboardService(); 